class MaintenancePage extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	render() {
		var imgPath = require("owls/default-owl-9.png");

		return (
			<div className="maintenancePage">
				<header className="pageHeader">
					<h1>Whooo's Reading is down for maintenance!</h1>
				</header>
				<div className="container text-center">
					<img src={ imgPath } />
					<p>We'll be back shortly!</p>
				</div>
			</div>
		);
	}
};

MaintenancePage.propTypes = PageStrictPropTypes({
});

module.exports = MaintenancePage;



// WEBPACK FOOTER //
// ./modules/components/technical/MaintenancePage.js